<template>
    <VAppLayout>
        <VContainer>
            <div class="cart-header">
                <button type="button"
                        class="cart-header-back"
                        aria-label="Back"
                        @click="goBack">
                    <svg width="11" height="20" viewBox="0 0 12 20" fill="none">
                        <path d="M10 2L2 10L10 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
                <div class="cart-header-content">
                    <h3>
                        {{ $t('pages.cart.yourOrder') }}
                    </h3>
                    <span class="cart-header-badge">
                        {{ $t('pages.cart.step') }} 2
                    </span>
                </div>
            </div>
            <div class="cart-client-info">
                <h6>
                    {{ $t('pages.cart.enterYourDetails') }}:
                </h6>
                <input type="text" v-if="!isSelfPickup" v-model="clientName" :placeholder="`${$t('pages.cart.fullName')} *`" required>
              <VuePhoneNumberInput v-if="isSelfPickup"
                                   v-model="tempPhone"
                                   default-country-code="PL"
                                   @update="updatePhone"
                                   :no-example="true"
                                   :preferred-countries="['PL', 'DE', 'ES', 'FR', 'UA', 'US']"
                                   :translations="getPhoneInputTranslations()"
                                   :border-radius="12"
                                   :color="brandColor"
                                   required />
                <div v-if="!isSelfPickup">
                    <v-select v-model="clientRoom"
                        :options="roomList"
                        label="name"
                        :placeholder="`${$t('pages.cart.selectRoomNumber')} *`"
                        required>
                        <!-- <template #option="{ name }">
                        <div style="display: flex; align-items: baseline">
                            <strong>{{ name }}</strong>
                            <span class="checkmark">✔</span>
                        </div>
                    </template> -->
                    </v-select>
                    <span class="cart-client-room-info">
                        <IconBase width="14"
                                  height="14"
                                  viewBox="0 0 14 14">
                            <IconInfo />
                        </IconBase>
                        {{ $t('pages.cart.checkRoomNumber') }}
                    </span>
                </div>

                <input type="text"
                       v-model="clientMessage"
                       :placeholder="$t('pages.cart.orderComment')">
            </div>
            <div class="cart-payment-method">
                <h6>
                    {{ $t('pages.cart.selectPaymentMethod') }}:
                </h6>
                <RadioButton v-if="comPaymentMethods.cash"
                             inputValue="cash"
                             :label="$t('pages.cart.cash')"
                             v-model="paymentMethod" />
                <RadioButton v-if="comPaymentMethods.card && isPaymentAdded"
                             inputValue="card"
                             :label="$t('pages.cart.paymentCard')"
                             v-model="paymentMethod" />
                <RadioButton v-if="comPaymentMethods.room"
                             inputValue="room"
                             :label="$t('pages.cart.chargeRoom')"
                             v-model="paymentMethod" />
              <RadioButton v-if="comPaymentMethods.cash_on_delivery"
                           inputValue="cash_on_delivery"
                           :label="$t('pages.cart.cashDelivery')"
                           v-model="paymentMethod" />
              <RadioButton v-if="comPaymentMethods.card_on_delivery"
                           inputValue="card_on_delivery"
                           :label="$t('pages.cart.cardDelivery')"
                           v-model="paymentMethod" />
              <RadioButton v-if="comPaymentMethods.cash_on_pickup"
                           inputValue="cash_on_pickup"
                           :label="$t('pages.cart.cashPickup')"
                           v-model="paymentMethod" />
              <RadioButton v-if="comPaymentMethods.card_on_pickup"
                           inputValue="card_on_pickup"
                           :label="$t('pages.cart.cardPickup')"
                           v-model="paymentMethod" />

            </div>
            <div class="cart-vat">
                <CheckboxButton :label="$t('pages.cart.vatRulesTitle')"
                                v-model="vatRulesAccepted" />
                <p class="cart-vat-error"
                   v-if="vatRulesAccepted">{{ $t('pages.cart.vatRulesDescriptionHotel') }}</p>
            </div>

            <div class="cart-totals">
                <div class="cart-totals-row cart-totals-row--grand">
                    <span class="cart-totals-label">{{ $t('pages.cart.total') }}</span>
                    <span class="cart-totals-value">{{ comFormTotalPrice }}</span>
                </div>
            </div>
        </VContainer>
    </VAppLayout>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import VAppLayout from "@/layouts/VAppLayout.vue";
import VContainer from "@/components/ui/VContainer.vue";
import RadioButton from '@/components/RadioButton.vue';
import CheckboxButton from '@/components/CheckboxButton.vue';
import IconBase from '@/components/IconBase.vue';
import IconInfo from '@/components/icons/IconInfo.vue';
import { EventBus } from "@/utils/eventBus";
import { normalizeHex } from "@/utils/colorTheme";


export default {
    name: "CartTab",
    props: ['orderId'],
    components: {
        VuePhoneNumberInput,
        vSelect,
        VContainer,
        VAppLayout,
        RadioButton,
        CheckboxButton,
        IconBase,
        IconInfo,
    },
    data() {
        return {
            clientName: '',
            clientMessage: '',
            formattedPhone: '',
            tempPhone: '',
            vatRulesAccepted: false,
        };
    },
    mounted() {
        if (!this.paymentMethod) {
            this.paymentMethod = Object.keys(this.comPaymentMethods).find(key => this.comPaymentMethods[key] === 1);
        }
        // The BottomDock "Pay" plate triggers this screen's own validated payment
        // (the in-page pay bar was removed in favour of the floating dock button).
        EventBus.$on('sm:pay', this.handlePayment);
    },
    beforeDestroy() {
        EventBus.$off('sm:pay', this.handlePayment);
    },
    methods: {
        handlePayment() {
            if (!this.areFieldsFilled()) {
                return;
            }
            const phone = this.formattedPhone.e164;
            window.localStorage.setItem('sm_clientPhone', phone);
            this.$store.dispatch('cartStore/SET_CLIENT_PHONE', phone);

            this.$store.dispatch('cartStore/MAKE_A_PAYMENT', { comment: this.clientMessage, personalInfo: this.clientName });
        },
        areFieldsFilled() {
            const nameValid = !!this.clientName || this.isSelfPickup;
            const phoneValid = !this.isSelfPickup || this.formattedPhone.isValid;
            const roomValid = !!this.clientRoom || this.isSelfPickup;

            if (nameValid && phoneValid && roomValid) {
                return true;
            }

            let errorMessage = '';

            if (!nameValid) {
                errorMessage += this.$t('pages.cart.invalidFullName') + '\n';
            }
            if (!phoneValid) {
                errorMessage += this.$t('pages.cart.invalidPhone') + '\n';
            }
            if (!roomValid) {
                errorMessage += this.$t('pages.cart.invalidRoomNumber') + '\n';
            }

            this.$toast.error(errorMessage, { position: 'top-center' });
            return false;
        },
        getPhoneInputTranslations() {
            return {
                countrySelectorLabel: this.$t('pages.cart.countrySelectorLabel'),
                countrySelectorError: this.$t('pages.cart.countrySelectorError'),
                phoneNumberLabel: this.$t('pages.cart.phoneNumberLabel')
            };
        },
        updatePhone(value) {
            this.formattedPhone = value;
        },
        goBack() {
            this.$router.back();
        },
    },
    computed: {
        comCompanyData() {
            return this.$store.getters['getCompanyData'];
        },
        comLocale() {
            return this.comCompanyData.locale;
        },
        comFormTotalPrice() {
            return this.$store.getters['cartStore/getFormattedCartTotal'];
        },
        isSelfPickup() {
            return this.$store.getters['cartStore/getDeliveryMethod'] && this.$store.getters['cartStore/getDeliveryMethod'].self_pickup === 1;
        },
        // Phone widget's border accent — the venue brand as a valid #hex (the lib's
        // `color` prop throws on anything else). Same source/normalisation as
        // --color-primary, so the border matches the other fields' focus colour.
        brandColor() {
            return normalizeHex(this.$store.getters['getBrandColor']) || '#6C1BE4';
        },
        comPaymentMethods() {
            return this.$store.getters['cartStore/getDeliveryMethod'].payment_methods ? this.$store.getters['cartStore/getDeliveryMethod'].payment_methods : this.$store.getters['getPaymentMethods'];
        },
        paymentMethod: {
            get() {
                return this.$store.getters['cartStore/getPaymentMethod'];
            },
            set(val) {
                this.$store.dispatch('cartStore/SET_PAYMENT_METHOD', val);
            }
        },
        roomList() {
            return this.comLocale.available_tables.filter(t => t.name);
        },
        clientRoom: {
            get() {
                return this.$store.getters['getTableData'];
            },
            set(val) {
                this.$store.commit('SET_TABLE_DATA', val);
            }
        },
        isPaymentAdded() {
            return this.comLocale.activePaymentCredentials === 1;
        }
    },
};
</script>

<style lang="scss" scoped>
.v-container {
    display: flex;
    flex-direction: column;
    gap: 16px;

    /* room for the floating nav (incl. the gradient pay plate) so the totals
       card clears it */
    padding-bottom: calc(var(--nav-height) + 76px);

    color: var(--text-primary);
}


h6 {
    font-size: var(--text-base);
    font-weight: var(--weight-bold);
    color: var(--text-primary);
    margin: 0;
    padding: 0;
}


.cart-header {
    position: sticky;
    top: 0;
    z-index: 11;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;

    margin: 0 -16px;
    /* top pad clears the status bar — the sticky header hits the very top edge
       of the scroll container now that the page paints under it (viewport-fit=cover) */
    padding: calc(14px + var(--safe-top, 0px)) 16px 14px;

    background: var(--header-blur-bg);
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    border-bottom: 1px solid var(--border-subtle);
    box-shadow: inset 0 1px 0 var(--header-hairline);

    &-back {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 34px;
        height: 34px;
        margin-left: -6px;

        border: none;
        background: transparent;
        color: var(--text-primary);
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        transition: transform var(--dur-fast) var(--ease-standard);

        &:active {
            transform: scale(0.9);
        }
    }

    &-content {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        min-width: 0;

        &>h3 {
            font-size: 26px;
            font-weight: var(--weight-black);
            line-height: 1.1;
            color: var(--text-primary);
            margin: 0;
            padding: 0;
        }
    }

    &-badge {
        display: inline-flex;
        align-items: center;

        padding: 4px 12px;
        border-radius: var(--radius-pill);

        font-size: var(--text-xs);
        font-weight: var(--weight-bold);

        background: var(--color-primary-soft);
        color: var(--color-primary);
    }
}

.cart-client-info {
    display: flex;
    flex-direction: column;
    gap: 14px;

    >input {
        height: 50px;

        padding: 0 16px;

        font-weight: var(--weight-medium);
        font-size: var(--text-base);
        color: var(--text-primary);

        border: 1px solid var(--border-subtle);
        border-radius: var(--radius-xl);
        background: var(--surface-card);

        &::placeholder {
            color: var(--text-muted);
        }

        &:hover,
        &:focus {
            outline: none;
            border-color: var(--color-primary);
            transition-duration: .3s;
        }
    }

    .vue-phone-number-input {
        z-index: 2;

        ::v-deep {
            .input-tel__input {
                border: 1px solid var(--border-subtle);
                box-shadow: none;

                &:focus {
                    box-shadow: 0 0 0 0 !important;
                }

                &::placeholder {
                    font-weight: var(--weight-medium);
                    font-size: var(--text-base);

                    color: var(--text-muted);
                }
            }

            .country-selector__label,
            .input-tel__label {
                font-weight: var(--weight-medium);

                color: var(--text-muted);
            }

            .country-selector__input {
                border: 1px solid var(--border-subtle);
                box-shadow: none;

                &:focus {
                    box-shadow: 0 0 0 0 !important;
                }
            }
        }
    }

    .v-select {
        font-weight: var(--weight-medium);
        font-size: var(--text-base);

        color: var(--text-muted);

        --vs-border-radius: var(--radius-xl);
        --vs-font-size: var(--text-base);
        --vs-search-input-color: var(--text-primary);
        --vs-dropdown-option--active-bg: var(--color-primary-soft);
        --vs-dropdown-option--active-color: var(--text-primary);
        --vs-dropdown-color: var(--text-primary);

        /* Dark mode: the chevron / clear controls (inside .vs__actions) default to
           a dark grey that vanishes on the dark field — force them white. */
        :root[data-theme="dark"] & {
            --vs-controls-color: #fff;
        }

        ::v-deep {
            .vs__search {
                height: 48px;

                padding: 0 16px;
                margin: 0;
                color: var(--text-primary);
                background: transparent;

                &::placeholder {
                    color: var(--text-muted);
                }
            }

            .vs__selected {
                color: var(--text-primary);
            }

            .vs__clear {
                width: auto;
            }

            .vs__actions {
                padding-right: 20px;
            }

            .vs__dropdown-toggle {
                padding-bottom: 0;

                border: 1px solid var(--border-subtle);
                background: var(--surface-card);
                box-shadow: none;

                &:hover {
                    border-color: var(--color-primary);
                    transition-duration: .3s;
                }
            }

            .vs__dropdown-menu {
                font-size: var(--text-base);
                font-weight: var(--weight-medium);
                line-height: 22px;
                background: var(--surface-card);
                color: var(--text-primary);

                /* match the field's outline so the open list reads as one piece */
                border: 1px solid var(--border-subtle);
            }
        }

        &.vs--open ::v-deep {
            .vs__selected {
                position: relative;
            }

            .vs__dropdown-toggle {
                border-color: var(--color-primary);
                border-bottom: 0;
                transition-duration: .3s;
            }
        }
    }

    .cart-client-room-info {
        display: flex;
        align-items: center;
        gap: 5px;

        margin-top: 6px;

        font-weight: var(--weight-medium);
        font-size: var(--text-sm);

        color: var(--color-primary);

        /* make the info glyph venue-aware (icon ships a hardcoded fill) */
        ::v-deep svg path {
            fill: var(--color-primary);
        }
    }
}

.cart-payment-method {
    display: grid;
    gap: 14px;
}

.cart-vat {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &-error {
        padding: 12px 14px;
        color: var(--danger);
        border: 1px solid var(--danger);
        background: var(--danger-soft);
        border-radius: var(--radius-xl);
        margin: 0;
        font-size: var(--text-sm);
    }
}

/* ---- Totals card ---- */
.cart-totals {
    display: flex;
    flex-direction: column;
    gap: 12px;

    padding: 18px;

    background: var(--surface-card);
    border: 1px solid var(--border-subtle);
    border-radius: 22px;

    &-row {
        display: flex;
        align-items: baseline;
        justify-content: space-between;

        &--grand {
            .cart-totals-label {
                font-size: 18px;
                font-weight: var(--weight-black);
                color: var(--text-primary);
            }

            .cart-totals-value {
                font-size: 22px;
                font-weight: var(--weight-black);
                color: var(--text-price);
            }
        }
    }

    &-label {
        font-size: var(--text-base);
        color: var(--text-secondary);
    }
}

/* ---- Venue-aware radio / checkbox accents ---- */
/* the shared icons ship a hardcoded violet; recolor them to the active brand. */
::v-deep .radio-wrapper,
::v-deep .checkbox-wrapper {
    .radio-label,
    .checkbox-label {
        color: var(--text-primary);
    }

    .icon-on rect,
    .icon-on path {
        stroke: var(--color-primary);
    }

    .icon-on rect:first-child {
        fill: var(--color-primary-soft);
    }

    .icon-on rect + rect,
    .icon-on path {
        fill: var(--color-primary);
    }
}
</style>
